export class MenuTagModel {
    id: number;
    hotel_id: number;
    table_name: string;
    table_record_id: number;
    menu_section_id: number;
    menu_item_id: number;
    menu_tag_template_id: number;
    menu_tag_category_id: number;
    menu_tag_category_name: string;
    type: string;
    name: string;
    comment: string;
    color_code: string;
    created_at: string;
    created_by: number;
    updated_at: string;
    updated_by: number;
  
    constructor(id = 0,
      table_name = '',
      table_record_id = 0,
      name = '',
      menu_tag_template_id = 0) {
      this.id = id;
      this.hotel_id = JSON.parse(localStorage.getItem('hotelId'));
      this.table_name = table_name;
      this.table_record_id = table_record_id;
      this.menu_section_id = 0;
      this.menu_item_id = 0;
      this.menu_tag_template_id = menu_tag_template_id;
      this.menu_tag_category_id = 0;
      this.menu_tag_category_name = '';
      this.type = '';
      this.name = name;
      this.comment = '';
      this.color_code = '';
    }
  }